import env from '@beam-australia/react-env';

class BaseConnector {
  constructor(baseApiUrl, jwtToken = null) {
    if (!baseApiUrl) {
      throw Error('Cannot instantiate constructor without base api url');
    }
    this.baseApiUrl = baseApiUrl;
    this.jwtToken = jwtToken;
    this.useCors = !this.isSameOrigin(window.location.href);
  }

  isSameOrigin(url) {
    let a = document.createElement('a');
    a.href = this.baseApiUrl;
    let b = document.createElement('a');
    b.href = url;
    return (
      a.protocol === b.protocol &&
      a.hostname === b.hostname &&
      a.port === b.port
    );
  }

  fetch(url, options = {}) {
    return new Promise((resolve, reject) => {
      fetch(url, options).then(resolve).catch(reject);
    });
  }

  // decorate fetch with authentication
  authFetch(url, options = {}) {
    const apiKeyFromEnv = env('EXT_X_API_HEADER');
    const headers =
      typeof apiKeyFromEnv !== 'undefined'
        ? new Headers({
            'Content-Type': 'application/json; charset=utf-8',
            'x-api-key': apiKeyFromEnv,
          })
        : new Headers({
            'Content-Type': 'application/json; charset=utf-8',
          });

    return new Promise((resolve, reject) => {
      options.headers = options.headers || headers;
      options.credentials = 'include';
      fetch(url, options).then(resolve).catch(reject);
    });
  }

  authPost(url, object) {
    return this.authFetch(url, {
      method: 'POST',
      body: JSON.stringify(object),
    });
  }

  authPatch(url, object) {
    return this.authFetch(url, {
      body: JSON.stringify(object),
      method: 'PATCH',
    });
  }

  authDelete(url, object = null) {
    return this.authFetch(url, {
      body: object ? JSON.stringify(object) : undefined,
      method: 'DELETE',
    });
  }

  authMultipartFormPatch(url, formData) {
    const apiKeyFromEnv = env('EXT_X_API_HEADER');
    const headers =
      typeof apiKeyFromEnv !== 'undefined'
        ? new Headers({
            'x-api-key': apiKeyFromEnv,
          })
        : new Headers();

    return this.authFetch(url, {
      headers: headers,
      method: 'PATCH',
      body: formData,
    });
  }

  authMultipartFormPost(url, formData) {
    const apiKeyFromEnv = env('EXT_X_API_HEADER');
    const headers =
      typeof apiKeyFromEnv !== 'undefined'
        ? new Headers({
            'x-api-key': apiKeyFromEnv,
          })
        : new Headers();

    return this.authFetch(url, {
      headers: headers,
      method: 'POST',
      body: formData,
    });
  }
}

export { BaseConnector };
